<template>
	<section class="block"
	         :style="{ backgroundImage: `url(${bgImg})`, backgroundColor: bgC}"
	         v-if="!hide"
	         >
		<!--	<section class="block" >-->
		<b-container :class="{'pr0':pr0, 'pl0':pl0, 'px0':px0}">
			<slot name="title"></slot>
			<slot name="content"></slot>
		</b-container>
	</section>
</template>

<script>
	export default {
		props: {
			bgImg: String,
			bgC: String,
			pr0: Boolean,
			pl0: Boolean,
			px0: Boolean,
			hide: Boolean,
		},
		data() {
			return {
			
			}
		},
		
	}
</script>

<style lang="scss" scoped>
	.block {
		padding: 70px 0;
		background-repeat: no-repeat;
		background-size: cover;
		@media only screen and (max-width: $md), only screen and (max-device-width: $md) {
			padding: 20px 0;
		}
	
		
		.pr0 {
			@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
				padding-right: 0;
			}
		}
		
		.pl0 {
			@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
				padding-left: 0;
			}
		}
		
		.px0 {
			@media only screen and (max-width: $sm), only screen and (max-device-width: $sm) {
				padding-left: 0;
				padding-right: 0;
			}
		}
	}
</style>